import React from 'react'
import PropTypes from 'prop-types'
import Button from 'shared/components/Button'
import AlertConfirmation from '../../../../assets/icon/alert-confirm.svg'
import { SPACING } from 'shared/constants/AppEnums'
import { Dialog, DialogActions, DialogContent, DialogTitle, Slide, Stack } from '@mui/material'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const DialogConfirmation = ({ open, handleClose, title, description, labelButton }) => {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => handleClose(0)}
            aria-describedby="alert-dialog-slide-description"
        >
            <div style={{ padding: '20px' }}>
                <DialogContent>
                    <Stack flexDirection={'row'} gap={SPACING / 2} alignItems={'center'}>
                        <Stack>
                            <img src={AlertConfirmation} />
                        </Stack>
                        <Stack flex={1}>
                            <label style={{ fontWeight: '600', fontSize: '14pt' }}>{title}</label>
                            <p style={{ fontWeight: '400', fontSize: '11pt', marginTop: '8px' }}>{description}</p>
                        </Stack>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        type='primary'
                        size='medium'
                        variant='contained'
                        label={labelButton ? labelButton : 'Hapus'}
                        disabled={false}
                        onClick={() => handleClose(1)}
                    />
                    <Button
                        type='primary'
                        size='medium'
                        variant='outlined'
                        label='Batal'
                        disabled={false}
                        onClick={() => handleClose(0)}
                    />
                </DialogActions>
            </div>
        </Dialog>
    )
}

DialogConfirmation.propTypes = {
    open: PropTypes.any,
    handleClose: PropTypes.func,
    description: PropTypes.string,
    title: PropTypes.string,
    labelButton: PropTypes.string
}